// Shared component styles. Preserve selector order, style values, and caller overrides.
import { pillButtonInteractiveSx, pillButtonFilledSx, toolbarPillButtonSx } from "./buttonStyles";

export const TAB_BLUE = "#3451F4";
export const TAB_PURPLE = "#9C4FFF";
export const TAB_LIGHT_BLUE = "#7BC4FF";
export const TAB_BORDER = "#D7E0EA";
export const companyHeaderStyles = {
  root: () => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: {
      xs: "flex-start",
      md: "center"
    },
    flexDirection: {
      xs: "column",
      md: "row"
    },
    gap: 2.25,
    pb: 2.75
  }),
  identity: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1.9,
    flexWrap: "wrap",
    minWidth: 0
  }),
  avatar: ({
    companyLogo
  }) => ({
    width: 40,
    height: 40,
    bgcolor: companyLogo ? "#F3E8FF" : "#2F6FFF",
    background: companyLogo ? "#F3E8FF" : "linear-gradient(135deg, #5EA8FF, #3451F4)",
    fontSize: 18,
    fontWeight: 700
  }),
  text: () => ({
    minWidth: 0,
    mr: {
      xs: 0,
      md: 1
    }
  }),
  name: () => ({
    fontSize: 15.5,
    fontWeight: 500,
    color: "#344054",
    lineHeight: 1.15
  }),
  website: () => ({
    mt: 0.3,
    fontSize: 14,
    color: "#9C4FFF",
    lineHeight: "24px"
  }),
  contactDivider: () => ({
    width: "1px",
    height: 26,
    backgroundColor: "#CBD5E1",
    mx: {
      xs: 0.4,
      md: 0.8
    },
    flex: "0 0 auto"
  }),
  contacts: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1.1,
    flexWrap: "wrap",
    minWidth: 0,
    maxWidth: "100%"
  }),
  socialDivider: () => ({
    width: "1px",
    height: 20,
    backgroundColor: "#CBD5E1",
    flex: "0 0 auto"
  }),
  filterIcon: () => ({
    fontSize: 18
  }),
  filterButton: () => [pillButtonInteractiveSx, pillButtonFilledSx, toolbarPillButtonSx, {
    alignSelf: {
      xs: "flex-end",
      md: "center"
    }
  }],
  section: () => ({
    py: 2.25,
    mb: 3,
    borderTop: `1px solid ${TAB_LIGHT_BLUE}`,
    borderBottom: `1px solid ${TAB_LIGHT_BLUE}`
  }),
  sectionRow: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2
  }),
  sectionTitle: () => ({
    color: TAB_BLUE,
    fontSize: 20,
    fontWeight: 700,
    fontFamily: "Be Vietnam Pro"
  }),
  actionDivider: () => ({
    fontSize: 13,
    color: "#D0D5DD"
  }),
  sectionAction: ({
    action
  }) => ({
    border: 0,
    background: "transparent",
    p: 0,
    m: 0,
    fontSize: 13,
    color: "#7C3AED",
    fontWeight: 600,
    cursor: action?.onClick ? "pointer" : "default",
    "&:hover": action?.onClick ? {
      textDecoration: "underline"
    } : undefined
  })
};
